import React, { useState } from 'react'
import PrintProfileDetails from '../../application_management/components/PrintProfileDetails'
import { shallowEqual, useSelector } from 'react-redux';

const CandidateProfile = () => {
    
    return (
        <div>
            <PrintProfileDetails />
        </div>
    )
}

export default CandidateProfile
